module.exports = __webpack_public_path__ + "0c2e93dd137edb28a5ec573b3adca803.svg";